export enum ShopifyPageType {
  HOME = "HOME",
  COLLECTION = "COLLECTION",
  PDP = "PDP",
  CART = "CART",
}

// Common types for frontend logic
export interface PageValidationConfig {
  pageType: ShopifyPageType;
  expectedMin: number;
  expectedMax: number;
  path: string | ((productHandle: string) => string);
}

export interface PageValidationResult {
  pageType: ShopifyPageType;
  foundSelectorCount: number;
  url: string;
  error: boolean;
  isWithinExpectedRange?: boolean; // Calculated on frontend
}
